import {VatExportType, VatReturnExport} from './vat-export.types';

/**
 * `exports[]`-Eintrag (Spec 3.4): kein `undefined`, `xmlContent` nur für ELSTER-XML (Phase 2).
 *
 * @author Anthony Nahas
 * @since 11.09.26
 */
export const buildVatExportEntry = (p: { type: VatExportType; fileName: string; filePath: string | null; url: string | null; sha256: string; uid: string; now: Date; xmlContent?: string | null }): VatReturnExport => ({
    type: p.type,
    fileName: p.fileName,
    filePath: p.filePath ?? null,
    url: p.url ?? null,
    sha256: p.sha256,
    xmlContent: p.xmlContent ?? null,
    createdAt: p.now,
    uid: p.uid,
});
